import React from "react";
import { TextField, Grid, Button, Typography, MenuItem, IconButton } from "@mui/material";
import { Add, Close } from "@mui/icons-material";
import { banques } from "../asset/variables";

export default function ChequesForm(props) {

    return(
        <Grid container columnSpacing={5} rowSpacing={3} >
            {props.repartition.map((piece, index) =>
            <Grid item sm={6} key={index}>
                <Grid container key={index} columnSpacing={1} rowSpacing={1}>
                    {props.repartition.length>1 && <Grid item sm={1}>
                        <IconButton 
                        aria-label="supprimer"
                        sx={{padding:0}} 
                        onClick={()=>{
                            props.setReptotal(old => Number((old-props.repartition[index].montant).toFixed(2)))
                            props.setRepartition(old => old.slice(0, index).concat(old.slice(index+1)))
                        }}>
                            <Close/>
                        </IconButton>
                    </Grid>}
                    <Grid item sm={9}>
                        <TextField
                        fullWidth
                        required={typeof props.isdepense ==='boolean' ? false : true}
                        select
                        label={"Banque"}
                        value={piece.banque}
                        onChange={(e)=> {
                            props.setRepartition(old => old.slice(0, index).concat([{banque: e.target.value, num_cheque:old[index].num_cheque, montant: old[index].montant}].concat(old.slice(index+1))))
                        }}>
                            {banques.map((label, index) => (
                                <MenuItem key={index} value={label}>
                                    <Typography>{label}</Typography> 
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item sm={7}>
                        <TextField
                        fullWidth
                        required={typeof props.isdepense ==='boolean' ? false : true}
                        label={"Numéro de chèque"}
                        value={piece.num_cheque}
                        onChange={(e)=> {
                            props.setRepartition(old => old.slice(0, index).concat([{banque: old[index].banque, num_cheque:e.target.value, montant: old[index].montant}].concat(old.slice(index+1))))
                        }}
                        />
                    </Grid>
                    <Grid item sm={5}>
                        <TextField
                        fullWidth
                        required
                        label="montant"
                        InputLabelProps={{shrink: true}}
                        inputProps={{step:"0.01", min:'0'}}
                        type="number"
                        value={piece.montant.toFixed(2)}
                        onChange={(e)=>{if(!isNaN(Number(e.target.value))){
                            props.setReptotal(old => Number((old-props.repartition[index].montant+Number(e.target.value)).toFixed(2)))
                            props.setRepartition(old => old.slice(0, index).concat([{banque: old[index].banque, num_cheque: old[index].num_cheque, montant:Number(Number(e.target.value).toFixed(2))}].concat(old.slice(index+1))))
                        }}}
                        />
                    </Grid>
                </Grid> 
            </Grid>)}
            {(props.isdepense || props.repartition[props.repartition.length-1].num_cheque!=='') && props.repartition[props.repartition.length-1].montant>0 && props.total>props.reptotal &&
            <Grid item sm={1}>
                <Button aria-label="ajouter un chèque" 
                variant="contained" 
                color="primary" 
                fullWidth
                sx={{paddingX:0, width:'100%'}}
                onClick={()=> props.setRepartition(old => old.concat([{banque: '', num_cheque:"", montant:0}]))}>
                    <Add sx={{margin:0}}/>
                </Button>
            </Grid>}
        </Grid>
    )
}